class ProductTabs {
  constructor() {
    this.init();
    // this.setupVariantListeners(); // Commented out - not needed for now but kept for future use
  }

  init() {
    const tabButtons = document.querySelectorAll('.product-tabs-desktop .product-tab-button');
    const tabPanels = document.querySelectorAll('.product-tabs-desktop .product-tab-panel');
    
    // Desktop tab functionality
    tabButtons.forEach((button, index) => {
      button.addEventListener('click', (e) => {
        e.preventDefault();
        
        // Remove active class from all buttons and panels
        tabButtons.forEach((btn) => {
          btn.classList.remove('active');
          btn.classList.remove('active-desktop');
        });
        tabPanels.forEach((panel) => {
          panel.classList.remove('active');
          panel.classList.remove('active-desktop');
        });
        
        // Add active class to clicked button
        button.classList.add('active');
        
        // Find and activate the corresponding panel by index
        if (tabPanels[index]) {
          tabPanels[index].classList.add('active');
        }
      });
    });
  }

  /*
  setupVariantListeners() {
    // Listen for variant changes
    document.addEventListener('variant:change', (event) => {
      this.updateVariantDescription(event.detail.variant);
    });

    // Also listen for the standard Shopify variant change event
    document.addEventListener('change', (event) => {
      if (event.target.matches('input[name="id"]')) {
        const variantId = event.target.value;
        this.updateVariantDescriptionById(variantId);
      }
    });

    // Listen for variant selector changes (radio buttons, select dropdowns)
    document.addEventListener('change', (event) => {
      if (event.target.matches('variant-radios input, variant-selects select')) {
        // Small delay to ensure variant data is updated
        setTimeout(() => {
          const selectedVariantElement = document.querySelector('[data-selected-variant]');
          if (selectedVariantElement) {
            try {
              const variantData = JSON.parse(selectedVariantElement.textContent);
              this.updateVariantDescription(variantData);
            } catch (e) {
              console.error('Error parsing variant data:', e);
            }
          }
        }, 100);
      }
    });

    // Listen for Shopify's built-in variant change events
    document.addEventListener('variantChange', (event) => {
      if (event.detail && event.detail.variant) {
        this.updateVariantDescription(event.detail.variant);
      }
    });
  }
  */

  /*
  updateVariantDescription(variant) {
    if (!variant || !variant.id) return;
    this.updateVariantDescriptionById(variant.id.toString());
  }

  updateVariantDescriptionById(variantId) {
    if (!window.variantDescriptions || !variantDescriptions[variantId]) return;

    const variantData = variantDescriptions[variantId];
    const descriptionContainers = document.querySelectorAll('.variant-description');

    descriptionContainers.forEach(container => {
      if (variantData.hasDescription && variantData.description) {
        // Extract content from metafield wrapper
        const cleanDescription = this.extractMetafieldContent(variantData.description);
        container.innerHTML = cleanDescription;
        container.style.display = 'block';
      } else {
        // Hide variant description
        container.style.display = 'none';
        container.innerHTML = '';
      }
    });
  }

  extractMetafieldContent(htmlString) {
    // Create a temporary DOM element to parse the HTML
    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = htmlString;
    
    // Look for the metafield wrapper and extract its content
    const metafieldWrapper = tempDiv.querySelector('.metafield-rich_text_field');
    if (metafieldWrapper) {
      return metafieldWrapper.innerHTML;
    }
    
    // If no wrapper found, return the original content
    return htmlString;
  }
  */
}

// Initialize when DOM is ready
document.addEventListener('DOMContentLoaded', () => {
  new ProductTabs();
});

// Handle dynamic content loading (for AJAX-loaded content)
document.addEventListener('shopify:section:load', (event) => {
  if (event.target.querySelector('.custom-product-tabs')) {
    new ProductTabs();
  }
});

// Export for module usage
if (typeof module !== 'undefined' && module.exports) {
  module.exports = ProductTabs;
}
